const ELLIPSIS = '…';

export const truncateText = (text, maxCharacters = 80) => {
  if (text.length > maxCharacters - ELLIPSIS.length) {
    return text.substring(0, maxCharacters - ELLIPSIS.length) + ELLIPSIS;
  }

  return text;
};

export const hasWhitespace = workspaceName => {
  return /\s/g.test(workspaceName);
};
